/**
 * Canvas layout constants
 * Centralized constants for navbar height, sidebar width, and item positioning constraints
 */

// UI overlay dimensions
export const NAVBAR_HEIGHT = 80;
export const LEFT_SIDEBAR_WIDTH = 60;
export const BOTTOM_TOOLBAR_HEIGHT = 100;

// Minimum safe positions for items (prevents items from being behind UI overlays)
export const MIN_ITEM_X = LEFT_SIDEBAR_WIDTH;  // 60px from left edge
export const MIN_ITEM_Y = NAVBAR_HEIGHT;       // 80px from top edge

// Grid snap size for item positioning
export const GRID_SNAP = 20;

// Fixed minimum canvas bounds (the canvas "floor")
// These define the minimum pannable area regardless of item positions
// Prevents bounds from contracting when items move, which causes viewport jumps
export const CANVAS_MIN_BOUNDS = {
  minX: -200,
  minY: -200,
  maxX: 3000,
  maxY: 3000,
};

// Fit-to-view padding (asymmetric to account for different UI overlays)
export const FIT_PADDING_TOP = NAVBAR_HEIGHT + 30;        // 110px - navbar + breathing room
export const FIT_PADDING_LEFT = LEFT_SIDEBAR_WIDTH + 30;  // 90px - sidebar + breathing room
export const FIT_PADDING_RIGHT = 50;
export const FIT_PADDING_BOTTOM = BOTTOM_TOOLBAR_HEIGHT + 20;  // 120px - bottom toolbar + breathing room

// Breathing room below navbar for auto-organize
export const AUTO_ORGANIZE_MIN_Y = NAVBAR_HEIGHT + 20; // 100px

// Extra room for cluster labels in cluster layout
export const CLUSTER_LAYOUT_MIN_Y = NAVBAR_HEIGHT + 40; // 120px
